/**
 * Logos reais das marcas das integrações (Fase E). Assets locais (bundled),
 * baixados das fontes oficiais. Uso nominativo — identificam o serviço real
 * que cada integração conecta no marketplace.
 *
 * "Mock" não tem marca (provider de dev/teste) → sem logo (cai no monograma).
 */
import asaas from "./asaas.png";
import belvo from "./belvo.png";
import cortecloud from "./cortecloud.png";
import dinabox from "./dinabox.png";
import enotas from "./enotas.png";
import mailgun from "./mailgun.png";
import nfeio from "./nfeio.png";
import pluggy from "./pluggy.png";
import sendgrid from "./sendgrid.png";
import ses from "./ses.png";
import promob from "./promob.png";

export const LOGOS_INTEGRACAO = {
  asaas,
  belvo,
  cortecloud,
  "dinabox-api": dinabox,
  "dinabox-file": dinabox,
  enotas,
  mailgun,
  nfeio,
  pluggy,
  sendgrid,
  ses,
  promob,
  // mock: sem logo (provider de dev/teste)
};

export function logoIntegracao(slug) {
  return LOGOS_INTEGRACAO[slug] || null;
}
